export default __webpack_public_path__ + "static/feature_03-d60d21654d9269ea7cf0ff50cc221c47.png";